import { NavLink } from 'react-router-dom';
import { IconBell } from '@/components/ui/IconBell';
import { useUnreadCount } from '@/shared/hooks/useNotifications';

export function NotificationBell() {
  const unread = useUnreadCount();
  const count = unread > 9 ? '9+' : String(unread);
  return (
    <NavLink to="/notifications" title="Notifications" aria-label={unread > 0 ? `Notifications, ${count} unread` : 'Notifications'}
      className="relative inline-flex items-center justify-center w-7 h-7 rounded-lg text-secondary hover:text-primary-text hover:bg-slate-50 transition">
      <IconBell size={15} />
      {unread > 0 && (
        <span aria-hidden="true" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-0.5 rounded-full bg-red-500 text-white text-[0.625rem] font-bold flex items-center justify-center">
          {count}
        </span>
      )}
    </NavLink>
  );
}
